module.exports = __webpack_public_path__ + "media/assets/images/plan03-b98663847282bf36b8eff899f5aab4ea.png";